import config from '~/config';
import { IResource } from '~/redux';

export const resourceAssetUrl = 
  (resource: IResource) => 
  (resource.type === 'Link' || resource.type === 'Video' || resource.type === 'Training') ? 
    undefined :
    config.strapiAPI.URL + resource.resource_asset[0]?.url;


// WEBPACK FOOTER //
// ./src/utils/resources.ts